import { ROLE_NAME } from '@/enums';
import { useGetMe } from '@/hooks/useGetProfileQuery';
import { IRole, Role, UserEntity } from '@/interfaces';

const getRoleLevel = (userRoleName: string) => {
  if (userRoleName.includes(ROLE_NAME.SUPER_ADMIN)) {
    return 1;
  }

  if (userRoleName.includes(ROLE_NAME.ADMIN)) {
    return 2;
  }

  return 3;
};

export const getOwnUserRoleLevel = (mainRole?: { name?: string }) => {
  const userRoleName: string = mainRole?.name || '';
  return getRoleLevel(userRoleName);
};

interface UserWithRole extends UserEntity {
  userRoles: { role: Role }[];
}

export const getUserRoleLevel = (user: UserWithRole) => {
  const { userRoles } = user;
  const role = userRoles[0]?.role;
  return {
    userRoleLevel: role?.level ?? getRoleLevel(''),
    userRoleName: role?.name ?? '',
  };
};

type SelectOptions = { label: string; value: string | number }[];

export const useGetRoleOptions = (allRoles: IRole[]) => {
  const { data: user } = useGetMe();
  const userLevel = user?.mainRole?.level ?? -Infinity;

  return allRoles.reduce((options, curr) => {
    const { level } = curr;
    if (level < userLevel) {
      return options;
    }
    return [
      ...options,
      {
        label: curr.name,
        value: curr.id,
      },
    ];
  }, [] as SelectOptions);
};
